export const i18n = {
  defaultLocale: 'en',
  locales: ['sv', 'en', 'da', 'no', 'ko', 'fr', 'de', 'es', 'pt'],
} as const;

export type Locale = (typeof i18n)['locales'][number];

export const defaultLocale = i18n.defaultLocale;
export const locales = i18n.locales;

export const localeNames: Record<Locale, string> = {
  sv: 'Svenska',
  en: 'English',
  da: 'Dansk',
  no: 'Norsk',
  ko: '한국어',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  pt: 'Português (Brasil)',
};

export const localeFlags: Record<Locale, string> = {
  sv: 'SV',
  en: 'EN',
  da: 'DA',
  no: 'NO',
  ko: 'KO',
  fr: 'FR',
  de: 'DE',
  es: 'ES',
  pt: 'BR',
};

// BCP 47 tag for <html lang> where it differs from the locale code: the
// `pt` locale is Brazilian Portuguese.
const htmlLangOverrides: Partial<Record<Locale, string>> = { pt: 'pt-BR' };

export function getHtmlLang(locale: Locale): string {
  return htmlLangOverrides[locale] ?? locale;
}

export function isValidLocale(locale: string): locale is Locale {
  return i18n.locales.includes(locale as Locale);
}

// Mirrors the client-side locale choice (localStorage) so server-rendered
// metadata such as the browser tab title can be localized.
export const localeCookieName = 'arkyv_locale';

export function isLocale(value: unknown): value is Locale {
  return (
    typeof value === 'string' &&
    (i18n.locales as readonly string[]).includes(value)
  );
}
